import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ThemeToggle from './ThemeToggle';

const Nav = styled.nav`
  padding: 1rem 2rem;
  background-color: ${props => props.theme.surface};
  box-shadow: 0 2px 4px ${props => props.theme.border};
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const NavList = styled.ul`
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavItem = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.surfaceText};
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: ${props => props.theme.primary};
  }
`;

const Navbar = () => {
  return (
    <Nav>
      <NavContainer>
        <NavList>
          <li><NavItem to="/">Home</NavItem></li>
          <li><NavItem to="/resume">Resume</NavItem></li>
          <li><NavItem to="/articles">Articles</NavItem></li>
          <li><NavItem to="/poetry">Poetry</NavItem></li>
          <li><NavItem to="/videos">Videos</NavItem></li>
        </NavList>
        <ThemeToggle />
      </NavContainer>
    </Nav>
  );
};

export default Navbar;
